import { type ReactNode } from 'react';

// Number chip used inside the Insights headline and bucket headers.
// Bordered + raised so each count reads as a label, not body text or an
// input. align-baseline keeps the numerals on the same line as the
// surrounding prose; px-1.5 gives just enough breathing room for digit
// pairs without inflating the height. The chip inherits its font size
// from the surrounding text so it sits naturally in both the headline
// and the smaller bucket headings.
export function MetricChip({ children }: { children: ReactNode }): JSX.Element {
  return (
    <span className="inline-block rounded border border-border bg-surface px-1.5 align-baseline font-mono tabular-nums text-text">
      {children}
    </span>
  );
}
